import { FormInstance } from 'antd';
import { Form, Input, Select } from 'antd/lib';
import { useImperativeHandle } from 'react';
import { banks } from '../../constants/bank';
import { map } from 'lodash';

interface EmployeeRemittanceFormProps {
  formRef: React.RefObject<
    FormInstance<{
      bankCode: string;
      bankAccount: string;
    }>
  >;
  initialValues?: {
    bankCode: string | null;
    bankAccount: string | null;
  };
}

export function EmployeeRemittanceForm(props: EmployeeRemittanceFormProps) {
  const { formRef, initialValues } = props;
  const [form] = Form.useForm<{
    bankCode: string;
    bankAccount: string;
  }>();

  useImperativeHandle(formRef, () => form, [form]);

  return (
    <Form
      form={form}
      autoComplete="off"
      preserve={false}
      initialValues={initialValues}
    >
      <Form.Item
        label="銀行代碼"
        name="bankCode"
        rules={[{ required: true, message: '請輸入銀行代碼' }]}
      >
        <Select
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          optionFilterProp="label"
          showSearch
          options={map(banks, (value) => ({
            label: `${value.bankCode} - ${value.bankName}`,
            value: value.bankCode,
          }))}
        />
      </Form.Item>
      <Form.Item
        label="銀行帳號"
        name="bankAccount"
        rules={[
          { required: true, message: '請輸入銀行帳號' },
          { pattern: /^\d*$/, message: '銀行帳戶必須為數字' },
        ]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
}
